import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { Route, useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { BrowserView, MobileView } from 'react-device-detect';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Button, Card, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';

import Paginacao from '../../../../Componentes/Paginacao';

import Registro from './Registro';
import { ListaEmpresasArquivosEstatisticasComponent } from "./components";
import ModalFiltros from './ModalFiltros';
import { formatarTamanhoBytes } from '../../../../Funcoes';

export default function ListaEmpresasArquivosEstatisticas(){

    // pega location
    const history = useHistory();
    const location = useLocation();
    let { path, url } = useRouteMatch();

    // parametros da url
    const {
        // idEmpresa = null
    } = useParams();

    // estados
    const [ carregando, alterarCarregando ] = useState(true);
    const [ mostrarFiltros, alterarMostrarFiltros ] = useState(false);
    const [ parametros, alterarParametros ] = useState({
        registrosPorPagina: 8,
        pagina: 1,
        pesquisa: null
    });
    const [ registros, alterarRegistros ] = useState([]);
    const [ totalRegistros, alterarTotalRegistros ] = useState(null);
    const [ totais, alterarTotais ] = useState({
        totalArquivos: 0,
        tamanhoTotal: 0
    });
    const [ erros, alterarErros ] = useState({});
    const [ registroMostrarDados, alterarRegistroMostrarDados ] = useState(null);
    const refAbrirFiltros = useRef(null);

    // efeitos

    useEffect(() => {

        // consulta registros
        consultar();

    }, [parametros]);

    useEffect(() => {

        // prepara
        let pathsConsultar = [
            '/painel/empresas/integracao/arquivos'
        ];
        let {
            aPartirDe
        } = location.state ?? {};

        // se retornar a essa rota
        if(pathsConsultar.includes(location.pathname) && (!aPartirDe || !['editarIntegracaoSistema'].includes(aPartirDe))){

            // consulta
            consultar();
        }

    }, [location.pathname]);


    // função para consultar
    async function consultar(){

        // cria o carregamento
        alterarCarregando(true);

        try{

            // consulta
            let { data } = await axios.get(`/empresas/arquivos/relatorio`, {
                params: {
                    ...parametros
                }
            });

            // sucesso

            // pega os registros e total
            alterarRegistros(data.registros);
            alterarTotalRegistros(data.totalRegistros);

            // altera totais
            alterarTotais({
                totalArquivos: data.totalArquivos,
                tamanhoTotal: data.tamanhoTotal
            });

        }catch(e){
            // erro

            // pega a resposta
            let response = e.response;
            // console.log(e);

            // verifica se tem a resposta
            if(response){

            }

        }finally{
            // finalizou

            // remove o carregamento
            alterarCarregando(false);
        }
    }

    // retorna registro
    function retornaRegistros(){

        // retorna registros organizado
        return registros.map((registro, indice) => 
            <Registro
                key={indice}
                indice={registro.indice ?? (indice + 1)}
                dadosEmpresa={registro.dadosEmpresa}
                total={registro.total}
                tamanhoTotal={registro.tamanhoTotal}
                relatorio={registro.relatorio}
                // clicouRegistro={() => {

                //     // altera para mostrar o modal com os dados do registro
                //     alterarRegistroMostrarDados(registro);
                // }}
            />
        )
    }

    return <ListaEmpresasArquivosEstatisticasComponent>
        <ModalFiltros
            elemento={refAbrirFiltros.current}
            mostrar={mostrarFiltros}
            alterarMostrar={alterarMostrarFiltros}
            parametros={parametros}
            alterarParametros={alterarParametros}
        />
        <Card.Body>
            <Card.Header className={'px-0'}>
                <div className={'d-flex '}>
                    <Card.Title className={'flex-grow-1 d-flex align-items-center mb-0'}>
                        Uso por empresas
                    </Card.Title>
                    
                    <div>
                        <Button
                            variant='light'
                            size='sm'
                            ref={refAbrirFiltros}
                            onClick={() => {

                                // define
                                alterarMostrarFiltros(true);
                            }}
                            style={{
                                fontSize: '0.9em',
                                boxShadow: '0 0 1px #b1b1b1',
                                border: 0,
                                display: 'flex',
                                gap: '0.2em',
                                alignItems: 'center'
                            }}
                        >
                            <FontAwesomeIcon className="icone" icon={faFilter} />
                            Filtrar / Ordenar
                        </Button>
                    </div>
                </div>
            </Card.Header>
            <div>
                {
                carregando ? <div className="p-5 text-center">
                    <FontAwesomeIcon icon={faSpinner} pulse /> Carregando...
                </div> : (
                        <div
                            className={'position-relative my-2'}
                        >
                            <table className='tabela'>
                                {totalRegistros > 0 && <tbody>
                                    <tr class="header">
                                        <th></th>
                                        <th className="text-center">Total</th>
                                        <th className="text-center">Tamanho</th>
                                        <th></th>
                                    </tr>
                                    { retornaRegistros() }
                                    <tr class="footer">
                                        <th></th>
                                        <th className="total text-center">{totais.totalArquivos}</th>
                                        <th className="tamanho text-center">{formatarTamanhoBytes(totais.tamanhoTotal)}</th>
                                        <th></th>
                                    </tr>
                                </tbody>}
                            </table>
                        </div>
                    )
                }
                
                <Paginacao
                    pagina={parametros.pagina}
                    registrosPorPagina={parametros.registrosPorPagina}
                    totalRegistros={totalRegistros}
                    alterouPagina={(pagina) => {
                        alterarParametros({...parametros, pagina: pagina});
                    }}
                />
            </div>
        </Card.Body>
        
        <Modal
            show={!!registroMostrarDados}
            onExited={() => {}}
            onHide={() => {
                alterarRegistroMostrarDados(null);
            }}
            size={'md'}
        >
            <Modal.Header className='border-0'>
                <Modal.Title 
                    as='h5' 
                    className={[
                        'text-center w-100',
                        'text-success'
                    ].join(' ')}
                >
                    Informações
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={'pt-0'}>
                <JSONPretty
                    id="json-info-servidor"
                    data={registroMostrarDados ? registroMostrarDados.dados.dados : null}
                    space="4"
                    mainStyle='color: #3f8a98;background: #f7f7f7;padding: 3px;border-radius: 3px;max-height: 80vh;overflow: auto;'
                />
            </Modal.Body>
        </Modal>
    </ListaEmpresasArquivosEstatisticasComponent>
    
}